<template>
  <div class="dashboard-container">
    <!-- show module -->
    <b-container fluid>
      <b-row v-if="user_profile.type === 'admin'">
        <b-button variant="outline-primary" v-on:click="open_model(true)"
          >Add Module</b-button
        >
      </b-row>
      <b-row class="mt-3">
        <b-col cols="2"></b-col>
        <b-col cols="8">
          <b-list-group>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
              v-for="item in section_list"
              v-bind:key="item.name"
              button
            >
              <span v-on:click="select_item(item.name, item.lock)">{{
                item.name
              }}</span>
              <div>
                <b-badge
                  class="mr-1"
                  variant="danger"
                  v-show="item.editable"
                  v-on:click="delete_data(item.name)"
                >
                  <b-icon
                    icon="x-circle-fill"
                    class="rounded bg-danger p-1"
                    scale="3.5"
                    variant="light"
                  ></b-icon>
                </b-badge>
                <b-badge variant="primary" v-show="!item.lock">
                  <b-icon
                    icon="unlock-fill"
                    class="rounded bg-primary p-1"
                    scale="3.5"
                    variant="light"
                  ></b-icon>
                </b-badge>
                <b-badge variant="danger" v-show="item.lock">
                  <b-icon
                    icon="lock-fill"
                    class="rounded bg-danger p-1"
                    scale="3.5"
                    variant="light"
                  ></b-icon>
                </b-badge>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="add_module" ref="add_module" title="Add Module" hide-footer>
      <b-form>
        <b-form-group
          id="add_module_form"
          label="Module Name"
          label-for="section_name"
        >
          <b-form-input
            id="section_name"
            v-model="section_name"
            placeholder="Name"
          ></b-form-input>
        </b-form-group>
        <b-button variant="success" @click="add_new_module">Add</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import db from "../../database/index";
import Swal from "sweetalert2";
const module_collection = db.collection("modules");

export default {
  name: "CourseAdmin",
  metaInfo: {
    title: "Market Moves - Course Admin",
    titleTemplate: "Course Admin",
  },
  props: ["user_data"],
  components: {},
  data() {
    return {
      id: this.$route.params.id,
      dataLoaded: false,
      discord_id: "",
      trades: [],
      tab_id: 1,
      section_name: "",
      section_list: [],
      user_profile: {},
      is_new: true,
    };
  },
  async mounted() {
    // Check is user is authorized to use dashboard
    // if (!this.$cookies.get("session_token")) this.$router.push({ path: "/" });

    if (this.user_data != undefined) {
      this.set_userdata(this.user_data);
      this.user_profile = this.user_data;
    } else {
      this.user_profile = this.get_userdata();
    }
    this.load_module();
  },
  methods: {
    handleChange(num) {
      this.tab_id = num;
    },
    add_new_module() {
      console.log(this.section_name);
      module_collection
        .doc(this.section_name)
        .set({})
        .then(() => {
          this.section_name = "";
          this.$refs["add_module"].hide();
          this.load_module();
        });
    },
    load_module() {
      this.section_list = [];
      let index = 0;
      module_collection.get().then((snapshot) => {
        if (!snapshot.empty) {
          snapshot.forEach((doc) => {
            let section = {};
            section.name = doc.id;
            section.index = index;
            if (this.user_profile["type"] === "admin") {
              section.editable = true;
            } else {
              section.editable = false;
            }
            if (
              index < this.user_profile["num_month"] ||
              this.user_profile["type"] === "admin"
            ) {
              section.lock = false;
            } else {
              section.lock = true;
            }
            index += 1;
            this.section_list.push(section);
          });
        }
      });
    },
    select_item(item, is_lock) {
      if (!is_lock) {
        localStorage.setItem("module_name", item);
        this.$router.push({
          name: "Course Topic",
          params: {
            module_name: item,
          },
        });
      }
    },
    set_userdata(data) {
      sessionStorage.setItem("user_data", JSON.stringify(data));
    },
    get_userdata() {
      return JSON.parse(sessionStorage.getItem("user_data"));
    },
    open_model(is_new) {
      if (is_new) {
        this.is_new = true;
      } else {
        this.is_new = false;
      }
      this.$refs["add_module"].show();
    },
    delete_data(module_name) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          module_collection
            .doc(module_name)
            .delete()
            .then(() => {
              this.load_module();
              Swal.fire("Deleted!", "Your data has been deleted.", "success");
            });
        }
      });
    },
  },
};
</script>

